module.exports = __webpack_public_path__ + "static/media/new-apache.4507b30e.svg";